import React from "react";
import Icon from "../../../../components/Icon";
import { terminosYCondicionesHogarFlexPdf } from "../../../../constants/files";
import { WHO_CAN_HIRE_SECTION } from "../../../../constants/sections";
import ExclusionsQuestions from "./ExclusionsQuestions";
import QuestionsTable from "./QuestionsTable";
import "./WhoCanHireSection.css";
import Datalayer from "../../../../libs/vendors/data-layer";
import { CLICK_ACTIONS, CLICK_DESCRIPTION } from "../../../../constants/datalayer";
import detailIcon from '../../../../assets/images/icons/detail.svg'
const WhoCanHireSection = () => {
    const openPdf = () => {
        Datalayer.sendClickAction(
            "Inicio",
            `${CLICK_ACTIONS.SELECT_LINK}: ${CLICK_DESCRIPTION.TERMS_CONDITIONS_HOGARFLEX}`
        );
    };

    return (
        <section className="landing-who-can-hire" id={WHO_CAN_HIRE_SECTION}>
            <div className="landing-who-can-hire__title">
                Conoce más de nuestro seguro
            </div>
            <div className="landing-who-can-hire__content">
                <div className="landing-who-can-hire__header">
                    <span />
                    <div className="landing-who-can-hire__header-title">
                        Hogar Flex Digital
                    </div>
                </div>
                <div className="landing-who-can-hire__body">
                    <QuestionsTable />
                    <ExclusionsQuestions />
                </div>
            </div>
            <div className="landing-who-can-hire__coverage-link">
                <Icon name="detail" image={detailIcon} />
                <div>
                    <a
                        href={terminosYCondicionesHogarFlexPdf}
                        target="_blank"
                        rel="noopener noreferrer"
                        onClick={openPdf}
                    >
                        Conoce el detalle de todas nuestras
                        <br /> coberturas y exclusiones aquí
                    </a>
                </div>
            </div>
        </section>
    );
};

export default React.memo(WhoCanHireSection);
